import React from 'react';
import { fieldToTextField } from 'formik-material-ui';
import PropTypes from 'prop-types';
import { InputAdornment, TextField } from '@material-ui/core';

import { inputUseStyles } from './styles';

const InputTextFiled = (props) => {
    const { startAdornment, endAdornment, showHelperTextOnError, color, ...restProps } = props;

    const inputClasses = inputUseStyles();
    const InputProps = {
        classes: {
            root: color === 'actHealth' ? inputClasses.actHealthColors : undefined,
            underline: inputClasses.underline,
            focused: inputClasses.focused,
            error: inputClasses.error,
        },
    };

    if (startAdornment) {
        InputProps.startAdornment = (
            <InputAdornment position="start" className={inputClasses.startAdornment}>
                {startAdornment}
            </InputAdornment>
        );
    }

    if (endAdornment) {
        InputProps.endAdornment = (
            <InputAdornment position="end" className={inputClasses.endAdornment}>
                {endAdornment}
            </InputAdornment>
        );
    }

    const textFieldData = fieldToTextField(restProps);
    if (!showHelperTextOnError) {
        if (textFieldData.error) {
            textFieldData.helperText = undefined;
        }
    }
    return <TextField InputProps={InputProps} {...textFieldData} />;
};

InputTextFiled.defaultProps = {
    startAdornment: null,
    endAdornment: null,
    showHelperTextOnError: true,
    color: 'default',
};

InputTextFiled.propTypes = {
    startAdornment: PropTypes.oneOfType([PropTypes.node, PropTypes.elementType, PropTypes.element]),
    endAdornment: PropTypes.oneOfType([PropTypes.node, PropTypes.elementType, PropTypes.element]),
    showHelperTextOnError: PropTypes.bool,
    color: PropTypes.oneOf(['actHealth', 'default']),
};

export default InputTextFiled;
